import { useState, useEffect } from 'react';
import { validateCpr } from '@flos/react-components';
import { errorTypes, track } from 'c9-tracking';

import { getStakeHolderInfo } from '../async/AsyncCalls';
import { useGlobalDispatch } from '../context/AppContext';
import { IGetStakeholderInfo, IRequestInfo } from '../interface/IPayload';
import { IAppProps } from '../interface/IAppProvider';

// Need further extension of this hook
// We can use it in the About you page as well
export function useStakeholderInfo(props: IAppProps) {
    const [userInfo, setUserInfo] = useState<IRequestInfo<number, string>>({
        value: NaN,
        progress: 'none',
        cpr: ''
    });
    const appDispatch = useGlobalDispatch();

    useEffect(() => {
        if (userInfo.progress === 'none') {
            if (!window.topContext.user.isLoggedOn) {
                setUserInfo({ value: NaN, progress: 'not-logged-on', cpr: '' });
            } else {
                setUserInfo({ value: NaN, progress: 'in-progress', cpr: '' });
                getStakeHolderInfo(props, appDispatch)
                    .then((ok: IGetStakeholderInfo) => {
                        const cprAge = validateCpr(ok.cprNo).age;
                        if (cprAge) {
                            setUserInfo({ value: cprAge, progress: 'logged-on-success', cpr: ok.cprNo });
                        } else {
                            setUserInfo({ value: NaN, progress: 'logged-on-error', cpr: '' });
                        }
                    })
                    .catch((error) => {
                        track.fault(`getStakeHolderInfo failed ${error}`, errorTypes.tech, 'User-data CustomerId');
                        setUserInfo({ value: NaN, progress: 'logged-on-error', cpr: '' });
                    });
            }
        }
    }, [props, appDispatch, userInfo]);

    return userInfo;
}
